import { ref } from 'config/constants'
import { showMessage } from 'data/messages/actions';
import {
    FETCH_BALANCE,
    FETCH_BALANCE_SUCCESS,
} from './types';

const Balance = ref.child("balance");

/* Pampaign */
export function fetchBalance(accountid) {
    return dispatch => {
        dispatch({
            type: FETCH_BALANCE,
            payload: { pending: true }
        });
        Balance.child(accountid).on('value', snapshot => {
            dispatch({
                type: FETCH_BALANCE_SUCCESS,
                payload: snapshot.val()
            });
        });
    };
}



// WEBPACK FOOTER //
// ./src/data/balance/actions.js